import { Link } from "@tanstack/react-router";

export function CTASection({
  title = "Fique por dentro do que importa",
  text = "Artigos, guias e dicas sobre controle de pragas urbanas publicados pela equipe da Dedetizadora em Chapecó.",
  buttonLabel = "Ver últimos artigos",
}: {
  title?: string;
  text?: string;
  buttonLabel?: string;
}) {
  return (
    <section className="py-16 md:py-20">
      <div className="container-svg">
        <div className="relative overflow-hidden rounded border-2 border-primary bg-[image:var(--gradient-hero)] p-8 md:p-14">
          <div className="relative max-w-2xl">
            <span className="eyebrow">Newsletter</span>
            <h2 className="mt-4 text-3xl font-bold tracking-tight md:text-4xl text-foreground">{title}</h2>
            <p className="mt-4 text-base text-muted-foreground md:text-lg">{text}</p>
            <div className="mt-8">
              <Link to="/blog" className="btn-primary">{buttonLabel}</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
